import { render } from "./RubyDemoView.vue?vue&type=template&id=570ed209"
import script from "./RubyDemoView.vue?vue&type=script&lang=js"
export * from "./RubyDemoView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2646400178/src/twilio-clone/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__